import { useState } from 'react';

export const getDefaultArea = ({ index, calculatorType, lineItemName }) => {
  return {
    key: `${index}`,
    name: lineItemName ? `${lineItemName} ${index + 1}` : '',
    length: '',
    width: '',
    depth: calculatorType === 'Volume' ? '3' : '',
    squareFootage: {
      value: '',
      changed: false
    }
  };
};

export const useCalculator = ({
  showMulchOptions, unitsPerCase, addAdditional, calculatorType, lineItemName
}) => {
  const [calculate, setCalculate] = useState({
    calcByArea: false,
    calcByLengthWidth: true,
    hasError: false,
    isClicked: false,
    quantity: 0,
    bulkQuantity: 0,
    step: 1,
    toggleText: 'Calculate by Square Footage',
    mulchType: 'wood',
    bagSize: '1.5',
    value: '',
    areas: [
      getDefaultArea({ index: 0, calculatorType, lineItemName })
    ],
    isFromLocalStorage: false
  });

  const addElement = () => {
    setCalculate((prevState) => {
      const {
        areas
      } = prevState;

      areas.push(getDefaultArea({ index: areas.length, calculatorType, lineItemName }));
      return {
        ...calculate,
        hasError: false,
        step: areas.length
      };
    });
  };

  const getDepthValue = (depthIndex) => {
    const { areas } = calculate;
    let depthValue = 1;
    if (calculatorType === 'Volume') {
      depthValue = parseInt(areas[depthIndex].depth, 10) / 12;
    }
    return Number.isNaN(depthValue) ? 1 : depthValue;
  };

  const calculateTotal = ({ isClick }) => {
    const {
      bagSize,
      mulchType,
      calcByArea,
      calcByLengthWidth,
      areas
    } = calculate;
    const units = showMulchOptions ? bagSize : unitsPerCase;
    const sizeValue = +units;
    let quantities = 0;
    let valueTotal = 0;
    let bulkQuantities = 0;
    let errorCal = false;
    if (calcByLengthWidth) {
      for (let index = 0; index < areas.length; index += 1) {
        errorCal = errorCal || areas[index].length === '' || areas[index].width === '';
        valueTotal += areas[index].length * areas[index].width * getDepthValue(index);
      }
    } else if (calcByArea) {
      for (let index = 0; index < areas.length; index += 1) {
        errorCal = errorCal || areas[index].squareFootage.value === '';
        valueTotal += Number(areas[index].squareFootage.value) * getDepthValue(index);
      }
    }
    // TODO: Add validation to prevent multiple of the same name?

    if (sizeValue) {
      let updateCoverage = valueTotal;
      if (addAdditional) {
        updateCoverage += (valueTotal * 0.10);
      }
      quantities = Math.ceil(updateCoverage / sizeValue);
    }

    if (showMulchOptions) {
      const bulkSize = mulchType === 'rubber' ? 38.5 : 5;
      bulkQuantities = Math.ceil(valueTotal / bulkSize);
    }

    const ret = {
      ...calculate,
      bulkQuantity: bulkQuantities,
      quantity: quantities,
      coverage: valueTotal,
      hasError: errorCal,
      isClicked: !errorCal && isClick,
    };
    setCalculate(ret);
    return ret;
  };

  return [calculate, { setCalculate, addElement, calculateTotal }];
};
